export default "__VITE_ASSET__C7WkCl0$__"